import axios from 'axios';
import {message } from 'antd';

export default (URl,request,success,failure,method='POST',data={},callback,errorCallback,certificate = false) => {
    return (dispatch) => {
        dispatch(request);
        let options = {
            url: URl,
            method: method, // 默认是 get
            data: data,
            timeout: 30000,
            withCredentials: certificate, // 默认的
        }
        return axios(options).then((res) => {
            if (res.status !== 200) {
                throw new Error('Fail to get response with status ' + res.status);
            }
            let json = res.data;

            if(json.code == 0){
                dispatch(success(json.data,json.product));
                callback && callback(json);
            }else{
                message.error(json.message);
                dispatch(failure(json.message));
                errorCallback && errorCallback();
            }
        }).catch((error) => {
            dispatch(failure(error));
            errorCallback && errorCallback();
        })
    };
}


// WEBPACK FOOTER //
// ./src/utils/asyncActionCreator.js